import { useFlipFlop } from 'hooks/useFlipFlop'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'

export function useModal(): [boolean, () => void, () => void] {
  const [showModal, openModal, closeModal] = useFlipFlop()
  const history = useHistory()

  useEffect(() => {
    let currentLocation = history.location.key

    return history.listen((location) => {
      if (currentLocation !== location.key) {
        closeModal()
      }
    })
  }, [history, closeModal])

  return [showModal, openModal, closeModal]
}
